import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { Controller, set, useForm } from "react-hook-form";
import User_Info from "../../common_components/user_info/User_Info";
import "./Update_Profile.css";
import Select from "react-select";
import { TextArea } from "@progress/kendo-react-inputs";
import { Context } from "../../../utils/context";
import { useDispatch } from "react-redux";
import { AuthUpdateProfile } from "../../../features/auth/Slice";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Update_Profile = () => {
  const fileInputRef = useRef();

  const dispatch = useDispatch();
  const { user, GetUser } = useContext(Context);

  console.log(user, "user");

  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile([file]);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile(null);
    }
  };

  const onSubmit = async (data) => {
    console.log("Form Data: ", data);

    const result = await dispatch(AuthUpdateProfile(data));

    if (result.payload.success) {
      setSuccess("Updated Successfully");
      setErr("");
      await GetUser();
      setTimeout(() => {
        setSuccess("");
      }, 3000);
      clearErrors();
    } else {
      setErr(result.payload.errors);
      setTimeout(() => {
        setErr("");
      }, 3000);
    }
  };

  useEffect(() => {
    if (user) {
      reset({
        ...user,
        password: user.show_password || "",
        confirm_password: user.show_password || "",
      });
    }
  }, [user, reset]);

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  return (
    <section className="Update_Profile Change_Password">
      <div className="user_info_div">
        <div className="row me-0 ms-0">
          <div className="col-lg-3 col-sm-8 col-12 my-3">
            <User_Info />
          </div>
        </div>
      </div>

      <div className="note_info_div">
        <div className="row me-0 ms-0">
          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-1 order-1 mb-2"></div>

          <div className="col-xxl-8 col-lg-6 col-md-12 order-lg-2 order-3 mb-2">
            {err && <div className="alert alert-danger">{err}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <div>
              <div className="manage_points_main_div mt-2">
                <div className="title_div">
                  <p className="title_text">:: Update Profile</p>
                </div>

                <div className="update_form_div">
                  <Form>
                    <div className="row">
                      <div className="col-md-7">
                        <div className="inputs_div">
                          <Form.Group
                            className="common_form_group"
                            controlId=""
                          >
                            <Form.Label>
                              <i class="fas fa-box-full    "></i> Name:
                            </Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              name="name"
                              {...register("name", {
                                required: "Name is required",
                              })}
                            />
                          </Form.Group>
                          {errors.name && (
                            <sub className="text-danger">
                              {errors.name.message}
                            </sub>
                          )}

                          <Form.Group
                            className="common_form_group"
                            controlId=""
                          >
                            <Form.Label>
                              <i className="fas fa-envelope"></i> Email:
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              {...register("email", {
                                required: "Email is required",
                              })}
                            />
                          </Form.Group>

                          {errors.email && (
                            <sub className="text-danger">
                              {errors.email.message}
                            </sub>
                          )}
                          <Form.Group
                            className="common_form_group"
                            controlId=""
                          >
                            <Form.Label>
                              <i className="fas fa-phone"></i> Contact No:
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="contact_no"
                              {...register("contact_no", {
                                required: " Contact No is required",
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message: "Mobile Number must be 10 digits",
                                },
                              })}
                            />
                          </Form.Group>
                          {errors.contact_no && (
                            <sub className="text-danger">
                              {errors.contact_no.message}
                            </sub>
                          )}

                          <Form.Group
                            className="common_form_group"
                            controlId=""
                          >
                            <Form.Label>
                              <i className="fas fa-key"></i> Password:
                            </Form.Label>
                            <div className="password_eye_field">
                              <Form.Control
                                type={showPassword ? "text" : "password"}
                                name="confirm_password"
                                {...register("password", {
                                  required: "password is required",
                                  validate: (value) =>
                                    value === getValues("password") ||
                                    "password do not match",
                                })}
                              />
                              <span
                                className="password_eye_icon"
                                onClick={() => setShowPassword((prev) => !prev)}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          </Form.Group>
                          {errors.password && (
                            <sub className="text-danger">
                              {errors.password.message}
                            </sub>
                          )}

                          <Form.Group
                            className="common_form_group"
                            controlId=""
                          >
                            <Form.Label>
                              <i className="fas fa-key"></i> Confirm Password:
                            </Form.Label>
                            <div className="password_eye_field">
                              <Form.Control
                                type={showCPassword ? "text" : "password"}
                                name="confirm_password"
                                {...register("confirm_password", {
                                  required: "Confirm Password is required",
                                  validate: (value) =>
                                    value === getValues("password") ||
                                    "Passwords do not match",
                                })}
                              />
                              <span
                                className="password_eye_icon"
                                onClick={() =>
                                  setShowCPassword((prev) => !prev)
                                }
                              >
                                {showCPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          </Form.Group>
                          {errors.confirm_password && (
                            <sub className="text-danger">
                              {errors.confirm_password.message}
                            </sub>
                          )}

                          <div className="form_footer">
                            <div className="btn_holder">
                              <button
                                className="blue_btn"
                                type="button"
                                onClick={handleSubmit(onSubmit)}
                              >
                                Update
                              </button>
                            </div>
                            <div className="btn_holder">
                              <button className="blue_btn">Reset</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-3 order-2 mb-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Update_Profile;
